(function ($) {
    var bottomTip = function () {

        var settings = {'section':''},
            currentViewport = 0,
            switchBottomTip = function (position) {

                position = position % 5;
                ajax_call({
                    module:"Articles",
                    action:"bottomTip_page",
                    type:0,
                    args:{
                        "page":position,
                        "section":settings.section
                    }
                }, function (data) {

                    $("#bottomsection_data").html(data);
                    if ($("#bottomsection_data .item").length < 6) {
                        currentViewport = -1;
                    }


                }, "html");


                currentViewport = position;
            },
            init = function (options) {

                settings = $.extend(settings, options);

                if ($("#bottomsection_data .item").length < 6) {
                    currentViewport = -1;
                }

                $("#bottomsection .rightarrow").click(function () {
                    switchBottomTip(currentViewport + 1);
                    return false;
                });

                $("a.bottomsection_links").on("click", function () {
                    console.log($(this).attr("href").substring(1));
                    $.fn.bottomTip({action:'changeSection', section:$(this).attr("href").substring(1)});
                    $("a.bottomsection_links").removeClass("selected");
                    $(this).addClass("selected");

                    return false;
                })

            };

        return {
            bootstrap:function (params) {
                if (typeof(params) != "object" || params.action == undefined) {
                    init(params);
                    return;
                }
                if (params.action == "switchBottomTip") {
                    switchBottomTip(params.viewport);
                }
                if (params.action == "changeSection") {
                    settings = $.extend(settings, params);
                    $("#bottomsection .bottomsection_links a").removeClass("selected");
                    //console.log($("#bottomsection .bottomsection_links a"));
                    switchBottomTip(0);
                    return;
                }

                return;
            }
        };
    }();
    $.fn.extend({
        bottomTip:bottomTip.bootstrap
    });
})(jQuery);